module.exports = __webpack_public_path__ + "img/Z82_01.1e806334.jpg";